import { rei } from "@/services/api"

class AvosService {
  static updateAvo (avo) {
    return rei.put(`avos/${avo.avo_id}`, { ...avo }).then(res => res.data)
  }
}

export default AvosService
